import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

/**
 * Route component that only allows access to users with specified roles.
 * If the user does not have permission, they are redirected to /training.
 */
const AdminRoute = ({ children, roles = ['admin', 'administrator'] }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!currentUser) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user has required role
  const userRole = (currentUser.role || '').toLowerCase();
  const allowedRoles = (roles || []).map((r) => r.toLowerCase());

  if (!userRole || !allowedRoles.includes(userRole)) {
    // Redirect to home portal if user does not have permission
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // User is authenticated and has required role
  return children;
};

export default AdminRoute;
